import React, { useContext, useEffect, useState } from "react";
import { BankAccountDto } from "../../../../dtos/catalogs/bankAccount/bankAccountDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import BankAccountDetailSkeleton from "./BankAccountDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import BankAccountDetailMain from "./BankAccountDetailMain";

interface IProps {
  model: BankAccountDto | null;
  modelUpdatedEvent: (newModel: BankAccountDto) => void;
}

interface BankAccountModel {
  id: string;
  name: string;
  uniqueCode: string;
  createdDate: Date;
  companyId: string;
  bankId: string;
  accountNumber: number;
  foreignBank: boolean;
  foreignBankName: string;
  closed: boolean;
  accountNo: string;
  currencyId: string;
  accountId?: string;
}

export const BankAccountDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<BankAccountModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("uniqueCode", model.uniqueCode);
      setValue("createdDate", model.createdDate);
      setValue("companyId", model.companyId);
      setValue("bankId", model.bankId);
      setValue("currencyId", model.currencyId);
      setValue("accountNumber", model.accountNumber);
      setValue("accountId", model.accountId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: BankAccountModel) => {
    if (action === "save") {
      const newModel: BankAccountDto = { ...model, ...data };
      await saveHandler(newModel);
    }
  };

  if (!model) {
    return (
      <>
        <BankAccountDetailSkeleton />
      </>
    );
  }
  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <BankAccountDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
